import {
  faBuilding,
  faChalkboard,
  faChalkboardTeacher,
  faHome,
  faTimesCircle,
  faLocationPin,
  faChartLine,
  faBook,
  faFilter,
  faFileLines,
  faChartBar,
  faDatabase,
  faUser,
  faBookOpenReader,
  faPeopleRoof,
  faHeadset,
} from "@fortawesome/free-solid-svg-icons";
import IRouter from "../interfaces/IRouter.interface";
import ExamIndex from "../views/private/Exams/Exam.index";
import StatisticsIndex from "../views/private/Statitics/Statitics.index";
import ExamById from "../views/private/Dashboard/Exam/ExamById";
import CreateInvigilators from "../views/private/Dashboard/Flow/CreateInvigilators";
import InvigilatorCenterTable from "../views/private/Dashboard/Flow/InvigilatorCenterTable";
import InvigilatorData from "../views/private/Dashboard/Flow/InvigilatorData";
import MappingColumnIds from "../views/private/Dashboard/Flow/MappingColumnIds";
import UploadExamShiftCSV from "../views/private/Dashboard/Flow/UploadExamShiftCSV";
import CSRReport from "../views/private/CSRReport";
import FiltersIndex from "../views/private/Filters/Filters.index";
import InvigilatorStatsIndex from "../views/private/InvigilatorStats/InvigilatorStats.index";
import VersionsIndex from "../views/private/Versions/Versions.index";
import ExportRequests from "../views/private/ExportRequests";
import Invigilator from "../views/private/Invigilator/Invigilator";
import MockExam from "../views/private/Dashboard/MockExam/MockExam";
import Counselling from "../views/private/Dashboard/Counselling/Counselling";
import UserLookup from "../views/private/UserLookup/UserLookup";
import ReverificationSearch from "../views/private/Dashboard/Exam/ReverificationSearch";
import AdminSupportUserIndex from "../views/private/AdminSupportUser/AdminSupportUser.index";
import CounsellingUserMapping from "../views/private/CounsellingUserMapping/CounsellingUserMapping";

export const baseUrl: string = "/dashboard";

const dashboardRoutes: IRouter[] = [
  {
    path: "statistics",
    element: <StatisticsIndex />,
    navbarShow: true,
    activeIcon: faChartLine,
    name: "Statistics",
  },
  {
    path: "csr",
    element: <CSRReport />,
    navbarShow: true,
    activeIcon: faFileLines,
    name: "Cen Reports",
  },
  {
    path: "exam",
    element: <ExamIndex />,
    navbarShow: true,
    activeIcon: faBook,
    name: "Exams",
  },
  {
    path: "mock-exam",
    element: <MockExam />,
    navbarShow: true,
    activeIcon: faBookOpenReader,
    name: "Mock Exam",
  },
  {
    path: "/dashboard/exam/:examId/:invigilatorId",
    element: <Counselling />,
    navbarShow: false,
    activeIcon: faPeopleRoof,
    name: "Counselling",
  },
  {
    path: "filters",
    element: <FiltersIndex />,
    navbarShow: true,
    activeIcon: faFilter,
    name: "Filters",
  },
  {
    path: "exam/:examId",
    element: <ExamById />,
    navbarShow: false,
    activeIcon: faBook,
    name: " ",
  },
  {
    path: "exam/:examId/reverification-search",
    element: <ReverificationSearch />,
    navbarShow: false,
    activeIcon: faBook,
    name: " ",
  },
  {
    path: "upload/:examId/:shiftId",
    element: <UploadExamShiftCSV />,
    navbarShow: false,
    activeIcon: faBook,
    name: " ",
  },
  {
    path: "mapping/:examId/:shiftId",
    element: <MappingColumnIds />,
    navbarShow: false,
    activeIcon: faBook,
    name: " ",
  },
  {
    path: "createInvigilators/:examId/:shiftId",
    element: <CreateInvigilators />,
    navbarShow: false,
    activeIcon: faBook,
    name: " ",
  },
  {
    path: "invigilatorcentertable/:examId/:shiftId",
    element: <InvigilatorCenterTable />,
    navbarShow: false,
    activeIcon: faBook,
    name: " ",
  },
  {
    path: "invigilatordata/:examId/:shiftId",
    element: <InvigilatorData />,
    navbarShow: false,
    activeIcon: faBook,
    name: " ",
  },
  {
    path: "invigilator-stats",
    element: <InvigilatorStatsIndex />,
    navbarShow: true,
    activeIcon: faChartBar,
    name: "Invigilator Stats",
  },
  {
    path: "invigilator",
    element: <Invigilator />,
    navbarShow: true,
    activeIcon: faUser,
    name: "Invigilator Logs",
  },
  {
    path: "app-version",
    element: <VersionsIndex />,
    navbarShow: true,
    activeIcon: faChartBar,
    name: "App Versions",
  },
  {
    path: "export-requests",
    element: <ExportRequests />,
    navbarShow: true,
    activeIcon: faDatabase,
    name: "Export Requests",
  },
  {
    path: "user-lookup",
    element: <UserLookup />,
    navbarShow: true,
    activeIcon: faUser,
    name: "User Lookup",
  },
  {
    path: "admin-support-users",
    element: <AdminSupportUserIndex />,
    navbarShow: true,
    activeIcon: faHeadset,
    name: "Support Users",
  },
  {
    path: "counselling-user-mapping",
    element: <CounsellingUserMapping />,
    navbarShow: true,
    activeIcon: faPeopleRoof,
    name: "Counselling Map",
  },
];

export default dashboardRoutes;
